import { Box, Stack } from '@mui/material';
import { type FC } from 'react';
import { VOICE_COMMAND_DOCS } from '../../data/voiceCommandsDocs';

interface VoiceModalListeningHintsDotBarProps {
  activeIndex: number;
  onSelectIndex: (index: number) => void;
}

export const VoiceModalListeningHintsDotBar: FC<VoiceModalListeningHintsDotBarProps> = ({
  activeIndex,
  onSelectIndex,
}) => (
  <Stack direction="row" justifyContent="center" gap={0.75} sx={{ mt: 1.75 }}>
    {VOICE_COMMAND_DOCS.map((_, i) => (
      <Box
        key={i}
        component="button"
        type="button"
        onClick={() => onSelectIndex(i)}
        sx={{
          width: activeIndex === i ? 20 : 6,
          height: 6,
          borderRadius: 1.5,
          background: activeIndex === i ? 'var(--tg-theme-button-color)' : 'rgba(255,255,255,0.1)',
          border: 'none',
          cursor: 'pointer',
          transition: 'all 0.3s',
          p: 0,
        }}
      />
    ))}
  </Stack>
);
